// declare const worker: any;
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from './environments/environment.prod';
import { enableProdMode } from '@angular/core';
import '@smile_identity/smart-camera-web';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import { ENABLE_MONITORING, logger, metrics, tracing } from '@mpt-fo/common/telemetry';

function isConfigEnabled(configVal, localEnvVal) {
  if (process.env?.NODE_ENV === 'development') {
    return localEnvVal;
  }
  return configVal === true || configVal === 'true';
}

if (environment.production) {
  enableProdMode();
}

registerSwiperElements();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (ENABLE_MONITORING) {
      tracing.setup();
      metrics.setupWebVitals();
    }
  })
  .catch((err) => {
    logger.error(err);
  });
